var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414042;}\n\t.st1{fill:none;stroke:#414042;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,3.7c-0.7-1-1.3-1.9-1.8-2.7c-0.1-0.1-0.2-0.2-0.3-0.3C17.9,0.3,17.3,0.5,17,1c-0.5,0.8-1.1,1.7-1.8,2.7 c-1,1.5-2.2,3.3-3.4,5.1c0.6,0.4,1.1,0.9,1.5,1.4c1.2-1.9,2.5-3.8,3.6-5.5c0.4-0.5,0.7-1,1-1.5c0.3,0.4,0.6,0.9,1,1.5 c3,4.4,7.4,11,7.4,14.3c0,2.3-0.9,4.4-2.4,5.9c-1.5,1.5-3.6,2.4-5.9,2.4s-4.4-0.9-5.9-2.4c-1.1-1.1-1.9-2.6-2.3-4.2 C9.1,20.9,8.5,21,7.9,21c-0.1,0-0.2,0-0.3,0c0.4,2.1,1.4,4,2.9,5.5c1.9,1.9,4.5,3,7.4,3s5.5-1.2,7.4-3.1c1.9-1.9,3.1-4.5,3.1-7.4 C28.3,15.1,23.7,8.3,20.5,3.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.4,
    cy: 14.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 9.8,
    className: "st0",
    width: 2.2,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 9.8,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 22.467 5.7285)",
    className: "st0",
    width: 2.2,
    height: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFat);
export default __webpack_public_path__ + "static/media/TotalFat.580977c9f81b05fe77b6b699011c8978.svg";
export { ForwardRef as ReactComponent };